<template>
	<div>
		<van-cell-group>
			<van-cell title="发票类型" :value="type" />
			<van-field
				    v-model="userName"
				    name="开票姓名"
				    label="开票姓名"
				    placeholder="开票姓名"
				    :rules="[{ required: true, message: '请输入开票姓名' }]"
				  />
			</van-cell-group>
			<van-cell title="发票内容" :value="content" />
			<van-cell title="开票金额" :value="money" />
			<van-field
			    v-model="ghdwsbh"
			    name="身份证号"
			    label="身份证号"
			    placeholder="身份证号"
			    :rules="[{ required: true, message: '请输入身份证号' }]"
			  />
		</van-cell-group>
		<van-cell-group>
			<van-field
			  v-model="email"
			  required
			  clearable
			  label="接收邮箱"
			  placeholder="请输入邮箱地址"
			/>
		</van-cell-group>
		<van-cell-group>
			<van-field name="uploader" label="身份证照" class="uploadBox">
				<template #input>
					<van-uploader v-model="idNoPics" :after-read="idCardImgUpload" :before-delete="deleteIdCardImg"
						accept="image/*" :max-size="2 * 1024 * 1024" multiple :max-count="2" upload-text="最多可上传2张"
						class="imgList" />
				</template>
			</van-field>
		</van-cell-group>
		<van-cell-group>
			<van-field name="uploader" label="房产证/租房合同" class="uploadBox">
				<template #input>
					<van-uploader v-model="propertyPics" :after-read="propertyPicsUpload" :before-delete="deletePropertyPics" accept="image/*"  :max-size="2 * 1024 * 1024" multiple :max-count="3" upload-text="最多可上传3张"
						class="imgList" />
				</template>
			</van-field>
		</van-cell-group>
		<div class="submitWrap">
			<van-button type="primary" class="submit" block @click="handleSubmit">提交申请</van-button>
		</div>
	</div>
</template>

<script>
	import {
		reqInvoiceApply,
		reqUploaderImg,
		uploadInvoice
	} from '../../api'
	import {
		Toast,
		ImagePreview
	} from 'vant'
	export default {
		name: "invoicing",
		data() {
			return {
				type: '增值税电子普通发票',
				headtype: '个人或事业单位',
				userName: '',
				ghdwmc:'',
				content: '明细',
				money: '',
				email: '',
				ghdwsbh: '',
				idNoPics: [],
				propertyPics:[]
			}
		},
		created() {
			console.log(this.$route.query)
			this.userId = this.$cookies.get('userInfo').userId;
			this.roomId = this.$route.query.roomId;
			this.recordId = this.$route.query.recordId;
			this.money = this.$route.query.curMoney;
			this.ghdwmc = this.$route.query.userName;
			this.userName = this.ghdwmc
			this.ghdwsbh = this.$route.query.idCardNo;
		},
		mounted() {

		},
		methods: {
			//身份证上传
			idCardImgUpload(file, detail) {
				console.log(file, detail)
				if (Array.isArray(file)) {
					for (var i = 0; i < file.length; i++) {
						this.handleUpload(file[i], 'idNoPics', i)
					}
				} else {
					this.handleUpload(file, 'idNoPics', detail.index)
				}
			},
			deleteIdCardImg(file, detail) {
				this.idNoPics.splice(detail.index,1)
			},
			propertyPicsUpload(file, detail) {
				if (Array.isArray(file)) {
					for (var i = 0; i < file.length; i++) {
						this.handleUpload(file[i], 'propertyPics', i)
					}
				} else {
					this.handleUpload(file, 'propertyPics', detail.index)
				}
			},
			deletePropertyPics(file, detail) {
				this.idNoPics.splice(detail.index,1)
			},
			handleUpload(file, obj, i) {
				file.status = 'uploading';
				file.message = '上传中...';
				let formData = new FormData();
				formData.append("file", file.file);
				uploadInvoice(formData).then(res => {
					console.log(res)
					if (res.success) {
						Toast.success({
							message: '上传成功！',
							className: 'apiLoading'
						});
						this[obj][i].url = res.data.imageUrl
						// this[obj][i] = res.data.imageUrl
						file.status = '';
						file.message = '';
					}
				})
			},
			handleSubmit() {
			console.log(this.ghdwmc,this.userName)
				// var verify = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
				if (!this.userName) {
					Toast.fail({
						message: "请输入开票姓名",
						className: 'apiLoading'
					});
					return
				}
				var idNoPics = []
				var propertyPics = []
				if(this.ghdwmc != this.userName){
					if (!this.ghdwsbh) {
						Toast.fail({
							message: "开票姓名变更，请输入身份证号",
							className: 'apiLoading'
						});
						return
					}
					if (this.idNoPics.length == 0) {
						Toast.fail({
							message: "开票姓名变更，请上传身份证照片",
							className: 'apiLoading'
						});
						return
					}
					if (this.propertyPics.length == 0) {
						Toast.fail({
							message: "开票姓名变更，请上传房产证或租房合同",
							className: 'apiLoading'
						});
						return
					}
					
					for(var i=0;i<this.idNoPics.length;i++){
						idNoPics.push(this.idNoPics[i].url)
					}
					for(var i=0;i<this.propertyPics.length;i++){
						propertyPics.push(this.propertyPics[i].url)
					}
				}
				
				var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
				if(!reg.test(this.email)){
					Toast.fail({
						message: "请正确输入您的邮箱",
						className: 'apiLoading'
					});
					return
				}
				let params = {
					userId: this.userId,
					recordId: this.recordId,
					roomId: this.roomId,
					ghdwmc: this.userName,
					ghdwsbh:this.ghdwsbh,
					money:this.money,
					email:this.email,
					idNoPics: idNoPics.join(','),
					propertyPics:propertyPics.join(',')
				}
				console.log(params)
				reqInvoiceApply(params).then(res => {
					if (res.status == 200) {
						Toast.success({
							message: '申请成功！',
							className: 'apiLoading'
						});
						this.$router.go(-1)
					} else {
						Toast.fail({
							message: '系统错误，请联系管理员！',
							className: 'apiLoading'
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">
	@import "../../common/stylus/mixins.styl"
</style>
<style>
	.van-cell-group {
		margin-top: 8px;
	}

	.van-cell {
		height: 98px;
		line-height: 98px;
		font-size: 30px;
		color: #222222;
		padding-left: 40px;
	}

	.van-field__control {
		text-align: right;
		padding-right: 40px;
	}

	.van-field__label {
		width: 120px;
	}

	.submitWrap {
		padding: 20px;
	}

	.submit {
		font-size: 30px;
		line-height: 88px;
		height: 88px;
	}

	.uploadBox {
		height: 180px;
	}

	.imgList .van-uploader__upload {
		width: 150px;
		height: 150px;
		font-size: 30px;
	}

	.van-uploader__upload-icon {
		font-size: 32px;
	}

	.van-uploader__upload-text {
		font-size: 18px;
	}

	.van-uploader__preview-image {
		width: 150px;
		height: 150px;
	}

	.van-uploader__preview-delete {
		width: 30px;
		height: 30px;
	}

	.van-uploader__preview-delete-icon {
		font-size: 24px;
		top: 3px;
		right: 3px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/invoicing/invoicing.vue